var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	5208: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(1397).then(() => (() => (__webpack_require__(1397))))))),
	8521: () => (loadStrictVersion("default", "graphql", false, [1,16,12,0], () => (__webpack_require__.e(7271).then(() => (() => (__webpack_require__(7271))))))),
	5899: () => (loadStrictVersion("default", "@hs-baumappe/legacy-ui", false, [1,1,1,14], () => (Promise.all([__webpack_require__.e(8775), __webpack_require__.e(2702), __webpack_require__.e(4532)]).then(() => (() => (__webpack_require__(8775))))))),
	4782: () => (loadStrictVersion("default", "@apollo/client", false, [1,3,13,8], () => (Promise.all([__webpack_require__.e(3679), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(3679))))))),
	1011: () => (loadStrictVersion("default", "react-router-dom", false, [1,6,30,3], () => (Promise.all([__webpack_require__.e(5707), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(5707))))))),
	2702: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (__webpack_require__.e(6850).then(() => (() => (__webpack_require__(4469))))))),
	4532: () => (loadStrictVersion("default", "@hs-baumappe/legacy-stylex", false, [1,1,0,3], () => (__webpack_require__.e(7374).then(() => (() => (__webpack_require__(7374))))))),
	6988: () => (loadStrictVersion("default", "yup", false, [2,0,32,11], () => (__webpack_require__.e(6065).then(() => (() => (__webpack_require__(6065))))))),
	9983: () => (loadStrictVersion("default", "formik", false, [1,2,4,9], () => (__webpack_require__.e(8285).then(() => (() => (__webpack_require__(8285))))))),
	1125: () => (loadStrictVersion("default", "i18next", false, [1,25,7,4], () => (__webpack_require__.e(6836).then(() => (() => (__webpack_require__(6836))))))),
	3062: () => (loadStrictVersion("default", "react-i18next", false, [1,16,5,3], () => (__webpack_require__.e(9232).then(() => (() => (__webpack_require__(9232))))))),
	397: () => (loadStrictVersion("default", "@hs-baumappe/graphql-errors", false, [1,1,5,1], () => (Promise.all([__webpack_require__.e(9364), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(9364))))))),
	7366: () => (loadStrictVersion("default", "@hs-baumappe/ui", false, [1,14,0,0], () => (Promise.all([__webpack_require__.e(30), __webpack_require__.e(2702), __webpack_require__.e(7406)]).then(() => (() => (__webpack_require__(30))))))),
	7406: () => (loadStrictVersion("default", "@hs-baumappe/stylex", false, [1,7,3,2], () => (__webpack_require__.e(5608).then(() => (() => (__webpack_require__(3227))))))),
	657: () => (loadStrictVersion("default", "@hs-baumappe/web-auth", false, [1,4,9,0], () => (Promise.all([__webpack_require__.e(3026), __webpack_require__.e(8521)]).then(() => (() => (__webpack_require__(3026))))))),
	2242: () => (loadStrictVersion("default", "@hs-baumappe/redkit", false, [1,2,1,2], () => (Promise.all([__webpack_require__.e(2089), __webpack_require__.e(1011), __webpack_require__.e(7366)]).then(() => (() => (__webpack_require__(2089))))))),
	3513: () => (loadStrictVersion("default", "@hs-baumappe/frontend-kit", false, [1,3,1,1], () => (__webpack_require__.e(6416).then(() => (() => (__webpack_require__(6416))))))),
	9694: () => (loadStrictVersion("default", "@hs-baumappe/sap-credentials", false, [1,1,0,0], () => (__webpack_require__.e(5872).then(() => (() => (__webpack_require__(3491))))))),
	5612: () => (loadStrictVersion("default", "date-fns", false, [1,3,2,0], () => (__webpack_require__.e(3213).then(() => (() => (__webpack_require__(3213))))))),
	9789: () => (loadStrictVersion("default", "pretty-bytes", false, [1,6,1,1], () => (__webpack_require__.e(4116).then(() => (() => (__webpack_require__(1735))))))),
	3835: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(6641).then(() => (() => (__webpack_require__(6641))))))),
	3939: () => (loadStrictVersion("default", "@hs-baumappe/pspdfkit", false, [1,1,6,0], () => (__webpack_require__.e(947).then(() => (() => (__webpack_require__(947))))))),
	620: () => (loadStrictVersion("default", "@hs-baumappe/file-upload", false, [1,4,1,1], () => (__webpack_require__.e(2003).then(() => (() => (__webpack_require__(2003))))))),
	7153: () => (loadStrictVersion("default", "@hs-baumappe/legacy-design-tokens", false, [1,1,0,1], () => (__webpack_require__.e(1087).then(() => (() => (__webpack_require__(1087))))))),
	2: () => (loadStrictVersion("default", "@hs-baumappe/forms", false, [1,5,2,4], () => (Promise.all([__webpack_require__.e(9225), __webpack_require__.e(2702), __webpack_require__.e(4532), __webpack_require__.e(9983)]).then(() => (() => (__webpack_require__(9225))))))),
	2501: () => (loadStrictVersion("default", "launchdarkly-react-client-sdk", false, [1,3,9,0], () => (__webpack_require__.e(2218).then(() => (() => (__webpack_require__(2218))))))),
	6751: () => (loadStrictVersion("default", "@hs-baumappe/design-tokens", false, [1,6,2,2], () => (__webpack_require__.e(5019).then(() => (() => (__webpack_require__(5019))))))),
	6444: () => (loadStrictVersion("default", "react-beautiful-dnd", false, [1,13,1,1], () => (Promise.all([__webpack_require__.e(4952), __webpack_require__.e(2702)]).then(() => (() => (__webpack_require__(4952))))))),
	1393: () => (loadStrictVersion("default", "file-type", false, [1,21,3,0], () => (__webpack_require__.e(8208).then(() => (() => (__webpack_require__(8208)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"397": [
		397
	],
	"657": [
		657
	],
	"1011": [
		1011
	],
	"1066": [
		2242,
		3513
	],
	"1125": [
		1125
	],
	"1393": [
		1393
	],
	"2702": [
		2702
	],
	"2866": [
		6444
	],
	"3062": [
		3062
	],
	"3835": [
		3835
	],
	"3919": [
		620,
		7153
	],
	"3939": [
		3939
	],
	"4532": [
		4532
	],
	"4782": [
		4782
	],
	"5208": [
		5208
	],
	"5899": [
		5899
	],
	"6299": [
		5612,
		9789
	],
	"6576": [
		2,
		2501
	],
	"6751": [
		6751
	],
	"6988": [
		6988
	],
	"7366": [
		7366
	],
	"7406": [
		7406
	],
	"8521": [
		8521
	],
	"9694": [
		9694
	],
	"9983": [
		9983
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}